var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_2486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2842 30 30 23.2842 30 15C30 6.71575 23.2842 0 15 0C6.71575 0 0 6.71575 0 15C0 23.2842 6.71575 30 15 30Z",
    fill: "url(#paint0_linear_1770_2486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58603 15.734C7.33951 14.7681 9.29689 13.962 11.1258 13.1517C14.2721 11.8246 17.431 10.5205 20.6218 9.30635C21.2426 9.09947 22.358 8.89716 22.4674 9.81716C22.4075 11.1194 22.1611 12.414 21.9921 13.7087C21.5632 16.5557 21.0675 19.3929 20.584 22.2305C20.4175 23.1757 19.2334 23.665 18.4758 23.0602C16.655 21.8303 14.8203 20.6124 13.0228 19.354C12.434 18.7557 12.98 17.8965 13.5058 17.4693C15.0055 15.9914 16.5958 14.7358 18.0171 13.1815C18.4005 12.2557 17.2677 13.036 16.8941 13.275C14.8411 14.6898 12.8383 16.1909 10.6738 17.4343C9.5682 18.0429 8.27958 17.5228 7.17445 17.1832C6.18356 16.7729 4.73165 16.3595 5.58603 15.734Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1770_2486",
    x1: 11.2517,
    y1: 1.251,
    x2: 3.75175,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1770_2486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderTelegram);
export default __webpack_public_path__ + "static/media/HeaderTelegram.667112d13766e8b9e412628b83d85d0a.svg";
export { ForwardRef as ReactComponent };